import React from 'react';

export function CheckboxColumnHeader(props) {
    return (
        <span>
            <input type="checkbox" className="k-checkbox k-checkbox-md k-rounded-md checkAllDocs" role="checkbox" aria-checked="true"
                onChange={(e) => props.checkAllChange(props.clickId, e.target.checked)} checked={props.checkAllChecked} />
        </span>
    );
}